export const STATUS_LEGEND = [
  { label: 'Operational', key: 'green' },
  { label: 'Informational', key: 'purple' },
  { label: 'Warning', key: 'yellow' },
  { label: 'Critical', key: 'red' },
  { label: 'Inactive', key: 'gray' },
];
